import { render, staticRenderFns } from "./certificationOrder.vue?vue&type=template&id=0af98ddb&"
import script from "./certificationOrder.vue?vue&type=script&lang=js&"
export * from "./certificationOrder.vue?vue&type=script&lang=js&"
import style0 from "./certificationOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports